export default "__VITE_ASSET__ZUyS03l3__"